// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Maturity Analysis — matches redesign HTML */

.maturity-analysis-page {
  font-family: Lato, sans-serif;
  color: #0b1e2d;
  width: 100%;
  padding-bottom: 40px;
}

.ma-pdf-print-host {
  position: absolute;
  left: -10000px;
  top: 0;
  width: 210mm;
  pointer-events: none;
  z-index: -1;
}

.ma-kpi-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 800px) {
  .ma-kpi-grid {
    grid-template-columns: 1fr;
  }
}

.ma-kpi {
  position: relative;
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12px;
  padding: 18px 20px 16px;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.05),
    0 10px 28px -20px rgba(0, 20, 109, 0.35);
}

.ma-kpi-stamp {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #e1f4f0;
  color: #076b5c;
  display: grid;
  place-items: center;
}

.ma-kpi-stamp svg {
  width: 14px;
  height: 14px;
}

.ma-kpi-eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #8a9ba7;
  margin: 0 0 10px;
  padding-right: 36px;
}

.ma-kpi-value {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.1;
  color: #0b1e2d;
}

.ma-kpi-value.is-coral {
  color: #d14a3e;
}

.ma-kpi-value.is-muted {
  color: #8a9ba7;
}

.ma-kpi-value.is-teal {
  color: #076b5c;
}

.ma-kpi-value.is-amber {
  color: #c98a16;
}

.ma-kpi-suffix {
  font-size: 15px;
  font-weight: 500;
  color: #5f7484;
}

.ma-bar-track {
  height: 6px;
  border-radius: 99px;
  background: #eaf0f0;
  margin-top: 12px;
  overflow: hidden;
}

.ma-bar-fill {
  display: block;
  height: 100%;
  border-radius: 99px;
  min-width: 0;
}

.ma-kpi-desc {
  margin-top: 10px;
  font-size: 13px;
  color: #5f7484;
  line-height: 1.4;
}

.ma-card {
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.05),
    0 10px 28px -20px rgba(0, 20, 109, 0.35);
  overflow: hidden;
}

.ma-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #eaeff7;
  flex-wrap: wrap;
}

.ma-card-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0b1e2d;
}

.ma-card-hint {
  font-size: 12.5px;
  color: #5f7484;
  display: inline-flex;
  align-items: center;
  gap: 0;
}

.ma-card-body {
  padding: 16px 18px 18px;
}

.ma-legend-swatch {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 3px;
  background: #0d9b87;
  margin-right: 6px;
  vertical-align: middle;
}

.ma-legend-dash {
  display: inline-block;
  width: 14px;
  border-top: 1.5px dashed #b0730f;
  margin: 0 6px 3px 14px;
  vertical-align: middle;
}

.ma-hbars {
  display: grid;
  gap: 14px;
}

.ma-hbar-row {
  display: grid;
  grid-template-columns: minmax(160px, 240px) 1fr 80px;
  gap: 14px;
  align-items: center;
}

@media (max-width: 700px) {
  .ma-hbar-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }
}

.ma-hbar-label {
  font-size: 13px;
  color: #0b1e2d;
  min-width: 0;
}

.ma-hbar-code {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 11.5px;
  color: #076b5c;
  margin-right: 6px;
}

.ma-hbar-val {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 12.5px;
  text-align: right;
  color: #5f7484;
}

.ma-empty {
  text-align: center;
  color: #5f7484;
  font-size: 14px;
  padding: 24px 12px;
}

.ma-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  min-height: 180px;
  padding: 28px 20px;
  border-radius: 10px;
  background:
    linear-gradient(180deg, #f7fafb 0%, #f1f4fa 100%);
  border: 1px dashed #d5dde8;
}

.ma-empty-state-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  margin-bottom: 4px;
  background: #e8f6f3;
  color: #076b5c;
}

.ma-empty-state-icon svg {
  width: 22px;
  height: 22px;
}

.ma-empty-state-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0b1e2d;
  letter-spacing: 0.01em;
}

.ma-empty-state-hint {
  margin: 0;
  max-width: 260px;
  font-size: 12.5px;
  line-height: 1.45;
  color: #5f7484;
}

.ma-card.is-empty {
  background: #fbfcfe;
}

.ma-card.is-empty .ma-card-body--chart {
  padding-top: 16px;
  padding-bottom: 16px;
}

/* ——— Shared analysis chart layout (mission + other view-analysis) ——— */
.ma-section-label {
  margin: 8px 0 10px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #8a9ba7;
}

.ma-chart-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 900px) {
  .ma-chart-grid {
    grid-template-columns: 1fr;
  }
}

.ma-chart-grid--single {
  grid-template-columns: 1fr;
  max-width: 520px;
}

.ma-card-body--chart {
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ma-chart-canvas {
  width: 100%;
  margin: 0 auto;
}

.ma-chart-canvas--pie {
  height: 168px;
  width: 168px;
  max-width: 168px;
}

.ma-chart-canvas--line {
  height: 240px;
  max-width: 100%;
  min-width: 0;
}

.ma-line-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  width: 100%;
}

.ma-bar-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(160px, 0.85fr);
  gap: 14px 18px;
  align-items: center;
  width: 100%;
}

.ma-bar-layout.is-multi {
  grid-template-columns: 1fr;
}

.ma-bar-layout.is-multi .ma-bar-legend {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 6px 10px;
}

@media (max-width: 700px) {
  .ma-bar-layout {
    grid-template-columns: 1fr;
  }
}

.ma-bar-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.ma-bar-legend-item {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-height: 22px;
  padding: 4px 8px;
  border-radius: 8px;
}

.ma-bar-legend-item:not(.is-muted) {
  background: #f7fafb;
}

.ma-bar-legend-item.is-muted {
  opacity: 0.42;
}

.ma-bar-legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 3px;
}

.ma-bar-legend-label {
  font-size: 12.5px;
  font-weight: 500;
  color: #0b1e2d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ma-bar-legend-value {
  font-family: Consolas, 'Courier New', monospace;
  font-size: 12px;
  font-weight: 700;
  color: #076b5c;
  white-space: nowrap;
}

.ma-bar-legend-item.is-muted .ma-bar-legend-value {
  color: #8a9ba7;
  font-weight: 500;
}

.ma-kpi-grid--3 {
  grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 1000px) {
  .ma-kpi-grid--3 {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 700px) {
  .ma-kpi-grid--3 {
    grid-template-columns: 1fr;
  }
}

/* Donut + side legend — denser, less dead space */
.ma-pie-layout {
  display: grid;
  grid-template-columns: 168px minmax(0, 1fr);
  gap: 18px 20px;
  align-items: center;
  width: 100%;
}

@media (max-width: 560px) {
  .ma-pie-layout {
    grid-template-columns: 1fr;
    justify-items: center;
  }
}

.ma-pie-visual {
  position: relative;
  width: 168px;
  height: 168px;
  flex: none;
}

.ma-pie-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  padding: 18px;
  text-align: center;
}

.ma-pie-center strong {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  color: #0b1e2d;
  font-variant-numeric: tabular-nums;
}

.ma-pie-center span {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.25;
  color: #5f7484;
  max-width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ma-pie-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  width: 100%;
}

.ma-pie-legend-item {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-height: 22px;
  padding: 4px 8px;
  border-radius: 8px;
}

.ma-pie-legend-item.is-muted {
  opacity: 0.42;
}

.ma-pie-legend-item:not(.is-muted) {
  background: #f7fafb;
}

.ma-pie-legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex: none;
}

.ma-pie-legend-label {
  font-size: 12.5px;
  font-weight: 500;
  color: #0b1e2d;
  line-height: 1.3;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ma-pie-legend-value {
  font-family: 'IBM Plex Mono', ui-monospace, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
  color: #076b5c;
  font-variant-numeric: tabular-nums;
}

.ma-pie-legend-item.is-muted .ma-pie-legend-value {
  color: #8a9ba7;
  font-weight: 500;
}

.ma-card-body--table {
  padding: 0;
}

.ma-card-body--table .MuiPaper-root {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
}

/* ——— Analysis data tables ——— */
.ma-analysis-table-wrap {
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 100%;
}

.ma-analysis-table-scroll {
  width: 100%;
  max-height: min(480px, 58vh);
  overflow: auto;
  overscroll-behavior: contain;
  border-radius: 0;
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #c5d0d8 transparent;
}

.ma-analysis-table-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.ma-analysis-table-scroll::-webkit-scrollbar-thumb {
  background: #c5d0d8;
  border-radius: 99px;
}

.ma-analysis-table-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.ma-analysis-table {
  width: 100%;
  min-width: 520px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
  font-family: Lato, sans-serif;
}

.ma-analysis-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 12px 18px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5f7484;
  background: #f7f9fc;
  border-bottom: 1px solid #e4ebf3;
  text-align: left;
  white-space: nowrap;
  box-shadow: 0 1px 0 #e4ebf3;
}

.ma-analysis-table thead th.is-numeric {
  text-align: left;
  width: 140px;
}

.ma-analysis-table thead th.is-sticky,
.ma-analysis-table tbody td.is-sticky {
  position: sticky;
  left: 0;
  z-index: 1;
  background: #fff;
}

.ma-analysis-table thead th.is-sticky {
  z-index: 3;
  background: #f7f9fc;
}

.ma-analysis-table tbody td {
  padding: 14px 18px;
  font-size: 13.5px;
  color: #0b1e2d;
  border-bottom: 1px solid #eef2f7;
  vertical-align: top;
  line-height: 1.45;
  word-break: break-word;
}

.ma-analysis-table tbody tr:last-child td {
  border-bottom: none;
}

.ma-analysis-table tbody tr:hover td {
  background: #f8fbfb;
}

.ma-analysis-table tbody tr:hover td.is-sticky {
  background: #f8fbfb;
}

.ma-analysis-table tbody td.is-primary {
  font-weight: 600;
  color: #00146d;
  white-space: nowrap;
  min-width: 140px;
  max-width: 220px;
  box-shadow: 1px 0 0 #eef2f7;
}

.ma-analysis-table tbody td.is-wrap {
  white-space: normal;
  min-width: 280px;
}

.ma-analysis-table tbody td.is-numeric {
  text-align: left;
  font-family: Consolas, 'Courier New', monospace;
  font-size: 13px;
  font-weight: 700;
  color: #076b5c;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  vertical-align: middle;
}

.ma-analysis-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ma-analysis-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef7f5;
  border: 1px solid #d5ebe6;
  color: #054f44;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
}

.ma-analysis-chip.is-empty {
  background: #f1f4fa;
  border-color: #dfe7e8;
  color: #8a9ba7;
  font-weight: 500;
}

.ma-analysis-table-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 10px 18px 12px;
  border-top: 1px solid #eef2f7;
  font-size: 12px;
  font-weight: 600;
  color: #8a9ba7;
  background: #fff;
}

.ma-loader {
  width: 100%;
  padding-bottom: 24px;
}

.ma-loader-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #eef7f5 0%, #f1f4fa 100%);
  border: 1px solid #d5ebe6;
}

.ma-loader-spinner {
  width: 28px;
  height: 28px;
  border-radius: 99px;
  border: 2.5px solid #c5e4dc;
  border-top-color: #0d9b87;
  animation: ma-spin 0.75s linear infinite;
  flex: none;
}

@keyframes ma-spin {
  to {
    transform: rotate(360deg);
  }
}

.ma-loader-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #00146d;
}

.ma-loader-hint {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: #5f7484;
}

.ma-skeleton-card {
  pointer-events: none;
}

.ma-skeleton {
  display: block;
  border-radius: 8px;
  background: linear-gradient(90deg, #eaf0f0 0%, #f7fafa 45%, #eaf0f0 90%);
  background-size: 200% 100%;
  animation: ma-shimmer 1.2s ease-in-out infinite;
}

@keyframes ma-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.ma-skeleton--eyebrow {
  width: 42%;
  height: 10px;
  margin-bottom: 14px;
}

.ma-skeleton--value {
  width: 34%;
  height: 28px;
  margin-bottom: 14px;
}

.ma-skeleton--bar {
  width: 100%;
  height: 6px;
  border-radius: 99px;
  margin-bottom: 12px;
}

.ma-skeleton--line {
  width: 68%;
  height: 10px;
}

.ma-skeleton--title {
  width: 48%;
  height: 14px;
}

.ma-skeleton--chart {
  width: 100%;
  height: 168px;
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/maturity-analysis.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,6BAA6B;EAC7B,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB;;4CAE0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB;;4CAE0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB;qDACmD;EACnD,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wEAAwE;EACxE,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Maturity Analysis — matches redesign HTML */\n\n.maturity-analysis-page {\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n  width: 100%;\n  padding-bottom: 40px;\n}\n\n.ma-pdf-print-host {\n  position: absolute;\n  left: -10000px;\n  top: 0;\n  width: 210mm;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.ma-kpi-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 800px) {\n  .ma-kpi-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ma-kpi {\n  position: relative;\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12px;\n  padding: 18px 20px 16px;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.05),\n    0 10px 28px -20px rgba(0, 20, 109, 0.35);\n}\n\n.ma-kpi-stamp {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #e1f4f0;\n  color: #076b5c;\n  display: grid;\n  place-items: center;\n}\n\n.ma-kpi-stamp svg {\n  width: 14px;\n  height: 14px;\n}\n\n.ma-kpi-eyebrow {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n  margin: 0 0 10px;\n  padding-right: 36px;\n}\n\n.ma-kpi-value {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #0b1e2d;\n}\n\n.ma-kpi-value.is-coral {\n  color: #d14a3e;\n}\n\n.ma-kpi-value.is-muted {\n  color: #8a9ba7;\n}\n\n.ma-kpi-value.is-teal {\n  color: #076b5c;\n}\n\n.ma-kpi-value.is-amber {\n  color: #c98a16;\n}\n\n.ma-kpi-suffix {\n  font-size: 15px;\n  font-weight: 500;\n  color: #5f7484;\n}\n\n.ma-bar-track {\n  height: 6px;\n  border-radius: 99px;\n  background: #eaf0f0;\n  margin-top: 12px;\n  overflow: hidden;\n}\n\n.ma-bar-fill {\n  display: block;\n  height: 100%;\n  border-radius: 99px;\n  min-width: 0;\n}\n\n.ma-kpi-desc {\n  margin-top: 10px;\n  font-size: 13px;\n  color: #5f7484;\n  line-height: 1.4;\n}\n\n.ma-card {\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12px;\n  margin-bottom: 16px;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.05),\n    0 10px 28px -20px rgba(0, 20, 109, 0.35);\n  overflow: hidden;\n}\n\n.ma-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #eaeff7;\n  flex-wrap: wrap;\n}\n\n.ma-card-head h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.ma-card-hint {\n  font-size: 12.5px;\n  color: #5f7484;\n  display: inline-flex;\n  align-items: center;\n  gap: 0;\n}\n\n.ma-card-body {\n  padding: 16px 18px 18px;\n}\n\n.ma-legend-swatch {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  border-radius: 3px;\n  background: #0d9b87;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n\n.ma-legend-dash {\n  display: inline-block;\n  width: 14px;\n  border-top: 1.5px dashed #b0730f;\n  margin: 0 6px 3px 14px;\n  vertical-align: middle;\n}\n\n.ma-hbars {\n  display: grid;\n  gap: 14px;\n}\n\n.ma-hbar-row {\n  display: grid;\n  grid-template-columns: minmax(160px, 240px) 1fr 80px;\n  gap: 14px;\n  align-items: center;\n}\n\n@media (max-width: 700px) {\n  .ma-hbar-row {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n}\n\n.ma-hbar-label {\n  font-size: 13px;\n  color: #0b1e2d;\n  min-width: 0;\n}\n\n.ma-hbar-code {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 11.5px;\n  color: #076b5c;\n  margin-right: 6px;\n}\n\n.ma-hbar-val {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 12.5px;\n  text-align: right;\n  color: #5f7484;\n}\n\n.ma-empty {\n  text-align: center;\n  color: #5f7484;\n  font-size: 14px;\n  padding: 24px 12px;\n}\n\n.ma-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 6px;\n  min-height: 180px;\n  padding: 28px 20px;\n  border-radius: 10px;\n  background:\n    linear-gradient(180deg, #f7fafb 0%, #f1f4fa 100%);\n  border: 1px dashed #d5dde8;\n}\n\n.ma-empty-state-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  margin-bottom: 4px;\n  background: #e8f6f3;\n  color: #076b5c;\n}\n\n.ma-empty-state-icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.ma-empty-state-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0b1e2d;\n  letter-spacing: 0.01em;\n}\n\n.ma-empty-state-hint {\n  margin: 0;\n  max-width: 260px;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.ma-card.is-empty {\n  background: #fbfcfe;\n}\n\n.ma-card.is-empty .ma-card-body--chart {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n/* ——— Shared analysis chart layout (mission + other view-analysis) ——— */\n.ma-section-label {\n  margin: 8px 0 10px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.ma-chart-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 900px) {\n  .ma-chart-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ma-chart-grid--single {\n  grid-template-columns: 1fr;\n  max-width: 520px;\n}\n\n.ma-card-body--chart {\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.ma-chart-canvas {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.ma-chart-canvas--pie {\n  height: 168px;\n  width: 168px;\n  max-width: 168px;\n}\n\n.ma-chart-canvas--line {\n  height: 240px;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.ma-line-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  width: 100%;\n}\n\n.ma-bar-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(160px, 0.85fr);\n  gap: 14px 18px;\n  align-items: center;\n  width: 100%;\n}\n\n.ma-bar-layout.is-multi {\n  grid-template-columns: 1fr;\n}\n\n.ma-bar-layout.is-multi .ma-bar-legend {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 6px 10px;\n}\n\n@media (max-width: 700px) {\n  .ma-bar-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ma-bar-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.ma-bar-legend-item {\n  display: grid;\n  grid-template-columns: 10px minmax(0, 1fr) auto;\n  gap: 8px;\n  align-items: center;\n  min-height: 22px;\n  padding: 4px 8px;\n  border-radius: 8px;\n}\n\n.ma-bar-legend-item:not(.is-muted) {\n  background: #f7fafb;\n}\n\n.ma-bar-legend-item.is-muted {\n  opacity: 0.42;\n}\n\n.ma-bar-legend-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n}\n\n.ma-bar-legend-label {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #0b1e2d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ma-bar-legend-value {\n  font-family: Consolas, 'Courier New', monospace;\n  font-size: 12px;\n  font-weight: 700;\n  color: #076b5c;\n  white-space: nowrap;\n}\n\n.ma-bar-legend-item.is-muted .ma-bar-legend-value {\n  color: #8a9ba7;\n  font-weight: 500;\n}\n\n.ma-kpi-grid--3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n@media (max-width: 1000px) {\n  .ma-kpi-grid--3 {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 700px) {\n  .ma-kpi-grid--3 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Donut + side legend — denser, less dead space */\n.ma-pie-layout {\n  display: grid;\n  grid-template-columns: 168px minmax(0, 1fr);\n  gap: 18px 20px;\n  align-items: center;\n  width: 100%;\n}\n\n@media (max-width: 560px) {\n  .ma-pie-layout {\n    grid-template-columns: 1fr;\n    justify-items: center;\n  }\n}\n\n.ma-pie-visual {\n  position: relative;\n  width: 168px;\n  height: 168px;\n  flex: none;\n}\n\n.ma-pie-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  padding: 18px;\n  text-align: center;\n}\n\n.ma-pie-center strong {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1;\n  color: #0b1e2d;\n  font-variant-numeric: tabular-nums;\n}\n\n.ma-pie-center span {\n  margin-top: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #5f7484;\n  max-width: 88px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.ma-pie-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  width: 100%;\n}\n\n.ma-pie-legend-item {\n  display: grid;\n  grid-template-columns: 10px minmax(0, 1fr) auto;\n  gap: 8px;\n  align-items: center;\n  min-height: 22px;\n  padding: 4px 8px;\n  border-radius: 8px;\n}\n\n.ma-pie-legend-item.is-muted {\n  opacity: 0.42;\n}\n\n.ma-pie-legend-item:not(.is-muted) {\n  background: #f7fafb;\n}\n\n.ma-pie-legend-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  flex: none;\n}\n\n.ma-pie-legend-label {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #0b1e2d;\n  line-height: 1.3;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ma-pie-legend-value {\n  font-family: 'IBM Plex Mono', ui-monospace, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 700;\n  color: #076b5c;\n  font-variant-numeric: tabular-nums;\n}\n\n.ma-pie-legend-item.is-muted .ma-pie-legend-value {\n  color: #8a9ba7;\n  font-weight: 500;\n}\n\n.ma-card-body--table {\n  padding: 0;\n}\n\n.ma-card-body--table .MuiPaper-root {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n/* ——— Analysis data tables ——— */\n.ma-analysis-table-wrap {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.ma-analysis-table-scroll {\n  width: 100%;\n  max-height: min(480px, 58vh);\n  overflow: auto;\n  overscroll-behavior: contain;\n  border-radius: 0;\n  /* Firefox */\n  scrollbar-width: thin;\n  scrollbar-color: #c5d0d8 transparent;\n}\n\n.ma-analysis-table-scroll::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.ma-analysis-table-scroll::-webkit-scrollbar-thumb {\n  background: #c5d0d8;\n  border-radius: 99px;\n}\n\n.ma-analysis-table-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.ma-analysis-table {\n  width: 100%;\n  min-width: 520px;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: auto;\n  font-family: Lato, sans-serif;\n}\n\n.ma-analysis-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  padding: 12px 18px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #5f7484;\n  background: #f7f9fc;\n  border-bottom: 1px solid #e4ebf3;\n  text-align: left;\n  white-space: nowrap;\n  box-shadow: 0 1px 0 #e4ebf3;\n}\n\n.ma-analysis-table thead th.is-numeric {\n  text-align: left;\n  width: 140px;\n}\n\n.ma-analysis-table thead th.is-sticky,\n.ma-analysis-table tbody td.is-sticky {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  background: #fff;\n}\n\n.ma-analysis-table thead th.is-sticky {\n  z-index: 3;\n  background: #f7f9fc;\n}\n\n.ma-analysis-table tbody td {\n  padding: 14px 18px;\n  font-size: 13.5px;\n  color: #0b1e2d;\n  border-bottom: 1px solid #eef2f7;\n  vertical-align: top;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.ma-analysis-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.ma-analysis-table tbody tr:hover td {\n  background: #f8fbfb;\n}\n\n.ma-analysis-table tbody tr:hover td.is-sticky {\n  background: #f8fbfb;\n}\n\n.ma-analysis-table tbody td.is-primary {\n  font-weight: 600;\n  color: #00146d;\n  white-space: nowrap;\n  min-width: 140px;\n  max-width: 220px;\n  box-shadow: 1px 0 0 #eef2f7;\n}\n\n.ma-analysis-table tbody td.is-wrap {\n  white-space: normal;\n  min-width: 280px;\n}\n\n.ma-analysis-table tbody td.is-numeric {\n  text-align: left;\n  font-family: Consolas, 'Courier New', monospace;\n  font-size: 13px;\n  font-weight: 700;\n  color: #076b5c;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.ma-analysis-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ma-analysis-chip {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #eef7f5;\n  border: 1px solid #d5ebe6;\n  color: #054f44;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.ma-analysis-chip.is-empty {\n  background: #f1f4fa;\n  border-color: #dfe7e8;\n  color: #8a9ba7;\n  font-weight: 500;\n}\n\n.ma-analysis-table-foot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px 12px;\n  border-top: 1px solid #eef2f7;\n  font-size: 12px;\n  font-weight: 600;\n  color: #8a9ba7;\n  background: #fff;\n}\n\n.ma-loader {\n  width: 100%;\n  padding-bottom: 24px;\n}\n\n.ma-loader-banner {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 16px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #eef7f5 0%, #f1f4fa 100%);\n  border: 1px solid #d5ebe6;\n}\n\n.ma-loader-spinner {\n  width: 28px;\n  height: 28px;\n  border-radius: 99px;\n  border: 2.5px solid #c5e4dc;\n  border-top-color: #0d9b87;\n  animation: ma-spin 0.75s linear infinite;\n  flex: none;\n}\n\n@keyframes ma-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ma-loader-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #00146d;\n}\n\n.ma-loader-hint {\n  margin: 2px 0 0;\n  font-size: 12.5px;\n  color: #5f7484;\n}\n\n.ma-skeleton-card {\n  pointer-events: none;\n}\n\n.ma-skeleton {\n  display: block;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #eaf0f0 0%, #f7fafa 45%, #eaf0f0 90%);\n  background-size: 200% 100%;\n  animation: ma-shimmer 1.2s ease-in-out infinite;\n}\n\n@keyframes ma-shimmer {\n  0% { background-position: 100% 0; }\n  100% { background-position: -100% 0; }\n}\n\n.ma-skeleton--eyebrow {\n  width: 42%;\n  height: 10px;\n  margin-bottom: 14px;\n}\n\n.ma-skeleton--value {\n  width: 34%;\n  height: 28px;\n  margin-bottom: 14px;\n}\n\n.ma-skeleton--bar {\n  width: 100%;\n  height: 6px;\n  border-radius: 99px;\n  margin-bottom: 12px;\n}\n\n.ma-skeleton--line {\n  width: 68%;\n  height: 10px;\n}\n\n.ma-skeleton--title {\n  width: 48%;\n  height: 14px;\n}\n\n.ma-skeleton--chart {\n  width: 100%;\n  height: 168px;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
